const o=()=>({styleOverrides:{root:({ownerState:t})=>{const{position:e}=t;return{"&:before":{...(e==="left"||e==="right")&&{flex:0,padding:0}}}}}});export{o as default};
